"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBookmarkSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M19.063 0H4.766A.766.766 0 004 .766v22.467l.007.106a.766.766 0 001.257.475l6.65-5.7 6.65 5.7a.766.766 0 001.265-.581V.766A.766.766 0 0019.063 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBookmarkSolid;
exports.default = _default;